import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("veloura_lang") || "de");

  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem("veloura_lang", l);
    document.documentElement.lang = l;
  }, []);

  const t = useCallback((key) => (translations[lang] && translations[lang][key]) || translations.de[key] || key, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
